import { render } from "./MenuLateralMobile.vue?vue&type=template&id=785fb4c1&scoped=true"
import script from "./MenuLateralMobile.vue?vue&type=script&lang=js"
export * from "./MenuLateralMobile.vue?vue&type=script&lang=js"

import "./MenuLateralMobile.vue?vue&type=style&index=0&id=785fb4c1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785fb4c1"]])

export default __exports__